// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"24":"0ca92405526b79d9","436":"f7ea6d97dc581df0","778":"a9998cdaf874d459"}[chunkId] + ".css";
};